import { useEffect } from 'react';

const useInfiniteScroll = (fn, options = {}) => {
  const { offset = 0 } = options;

  useEffect(() => {
    const onScroll = () => {
      if (
        document.documentElement.clientHeight +
          document.documentElement.scrollTop >=
        document.documentElement.scrollHeight
      ) {
        fn();
      }
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, [fn, offset]);
};

export default useInfiniteScroll;
